import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';

export type NotFoundPageViewModel = ReturnType<typeof useNotFoundPageViewModel>;

export type NotFoundPageViewModelProps = LoggingContext;

export const useNotFoundPageViewModel = ({
  logger,
}: NotFoundPageViewModelProps = {}) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // @TODO: report telemetry about not found page access
    logger?.error(
      {
        status: 404,

        location: {
          key: location.key,
          pathname: location.pathname,
          search: location.search,
          hash: location.hash,
          state: location.state,
        },
      },
      '404 Not Found - User navigated to a non-existent route',
    );
  }, [
    location.key,
    location.pathname,
    location.search,
    location.hash,
    location.state,
    logger,
  ]);

  return {
    location,
    navigate,

    logger,
  };
};
